
import { NudosGenericModal, NudosModalContent } from 'components/NudosComponents';
import { InudosButton } from 'components/NudosComponents/NudosButton/NudosButton';
import BordDownloadQrModalContent from './Components/BordDownloadQrModalContent/BordDownloadQrModalContent';
import { IQrCard } from './Components/QRcard/QRcard';

interface IBordDownloadQrModal {
  downloadPercent: number;
  buttonProps: InudosButton;
  closeModalCallback: () => void;
  qrDataProps: IQrCard[];
  onGenerationComplete?: () => void;
}

const BordDownloadQrModal = ({
  buttonProps,
  qrDataProps,
  closeModalCallback,
  onGenerationComplete
}: IBordDownloadQrModal) => {
  return (
    <NudosGenericModal
      closeModalCallback={closeModalCallback}
      modalContent={
        <NudosModalContent
          modalContentTitle=""
          hideNudosIcon
          excludeHeader
          toCloseModal={closeModalCallback}
          CustomModalComponent={
            <BordDownloadQrModalContent
              closeModalCallback={closeModalCallback}
              onGenerationComplete={onGenerationComplete}
              qrDataProps={qrDataProps}
              buttonProps={buttonProps}
            />
          }
          customWidth="466px"
          customHeight="220px"
        />
      }
    />
  );
};

export default BordDownloadQrModal;
